module.exports = __webpack_public_path__ + "static/media/home.eec84645.jpg";